import ProgressionResourceInstance from "../../../../resources/expapiunified/Progression.resource.js";
import { createUnifiedRestApi } from "../utils.js";
const {
  epic: progressionsEpic,
  reducer: progressionsReducer,
  actions: progressionsActions,
  matchers: progressionsMatchers,
  selectors,
  getDefaultReducerState: getDefaultProgressionsReducerState
} = createUnifiedRestApi(
  ProgressionResourceInstance,
  "progressions",
  (state) => state.progressions
).create();
const {
  selectAll: selectAllProgressions,
  selectById: selectProgressionById,
  selectCreateOrUpdateAsyncRequest: selectCreateOrUpdateProgressionAsync,
  selectDeleteAsyncRequest: selectDeleteProgressionAsync,
  selectGetAsyncRequest: selectGetProgressionAsync,
  selectQueryAsyncRequest: selectQueryProgressionsAsync
} = selectors;
const {
  getAsync: getProgressionAsync,
  queryAsync: queryProgressionsAsync,
  createOrUpdateAsync: createOrUpdateProgressionAsync,
  deleteAsync: deleteProgressionAsync
} = progressionsActions;
export {
  createOrUpdateProgressionAsync,
  deleteProgressionAsync,
  getDefaultProgressionsReducerState,
  getProgressionAsync,
  progressionsEpic,
  progressionsMatchers,
  progressionsReducer,
  queryProgressionsAsync,
  selectAllProgressions,
  selectCreateOrUpdateProgressionAsync,
  selectDeleteProgressionAsync,
  selectGetProgressionAsync,
  selectProgressionById,
  selectQueryProgressionsAsync
};
//# sourceMappingURL=progressions.js.map
